import React from 'react';
import { graphql } from 'gatsby';

import Page from '../components/global/page';
import HomeTemplate from '../templates/index-template';

export default ({ data }) => {
	return (
		<Page page="home" title={data.copy.title}>
			<HomeTemplate copy={data.copy} offerData={data.offerData} />
		</Page>
	);
};

export const HomeQuery = graphql`
	{
		offerData: allOffersJson(
			filter: { published: { eq: true } }
			sort: { fields: date, order: DESC }
		) {
			nodes {
				ctaText
				img
				name
				small
				content
			}
		}
		copy: pagesJson(page: { eq: "home" }) {
			title
			hero {
				hasContest
				title
				subtext
				bimg
				cta {
					text
					link
				}
			}
			opener {
				copy
				cta {
					link
					text
				}
				title
			}
			facts {
				top
				title
				circles {
					text
					text2
					number
				}
			}
			learn {
				circles {
					alt
					photo
					text
					link
				}
				title
				top
			}
			rocks {
				bimg
				cta {
					link
					text
				}
				logo {
					src
					alt
				}
				text
			}
			form {
				top
				title
				copy
			}
		}
	}
`;
